(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-article-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-article-mom-360"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.js-blog-categories-content').hide();
    $('.js-blog-categories-header').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.js-blog-categories-content').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-article"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.js-blog-categories-content').hide();
    $('.js-blog-categories-header').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.js-blog-categories-content').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-blog-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-contact"] && !Shopify.designMode) return;
  try {
    

  $('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
 if ($(this).is(':checked')) {
    $('.contact-button').prop("disabled", true);
 } else {
  if ($('.checks').filter(':checked').length < 1){
 $('.contact-button').attr('disabled',false);}
 }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-experts"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.single-expert-bio').hide();
    $('.single-expert-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.single-expert-bio').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ingredients"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.pdp-ingredient-content').hide();
    $('.pdp-ingredient-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.pdp-ingredient-content').slideUp(200);
});

  } catch(e) { console.error(e); }
})();
})();
